import { render, staticRenderFns } from "./AsyncLoading.vue?vue&type=template&id=55d01da9&functional=true&"
import script from "./AsyncLoading.vue?vue&type=script&lang=js&"
export * from "./AsyncLoading.vue?vue&type=script&lang=js&"
import style0 from "./AsyncLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
